export interface UserState {
  active: boolean;
}

export const initialUserState: UserState = {
  active: true
};
